<template>
  <div class="container">
      <main>
            <Search @getInputValue='getInputValue' @search='search' @add='add'>还款管理</Search>
            <el-table
                :data="list"
                header-align="center"
                :row-class-name="TableRowClassName"
                style="width:100%;padding:0 0px;height:100%"
                :header-cell-style="{ background: '#EBEEF8',height: '45px' }"
                :cell-style="{padding:'0px'}"
            >
            <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="customerName"
            label="客户名称"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="factorNo"
            label="设备编号"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="periodsNum"
            label="分期数"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="startDate"
            label="贷款日期"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.startDate | timeFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="repaymentDate"
            label="应还日期"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.repaymentDate | timeFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="status"
            label="还款状态"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span :style="{color:scope.row.color}">{{scope.row.status}}</span>
            </template>
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            fixed="right"
            min-width="80"
            width="80"
            >
                <template slot-scope="scope">
                    <div style="display:flex;width:100%;justify-content:space-around">
                        <el-button @click="edit(scope.row)" type="text" size="mini" class="btn">
                            <i class="el-icon-finished" style="fontSize:19px"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            </el-table>
            <Pagination :pageTotal="pageTotal" @currentPage="currentPage"/>
        </main>
        <el-dialog :title="isEdit?'编辑':'新增'"  :visible.sync="dialogFormVisible" center :close-on-click-modal="false" style="width:60%;margin:0 auto;marginTop:-50px">
            <div class="dialogline"></div>
                <el-form :model="dialogForm" class="dialogForm" :rules="formRules" ref="formRules">
                    <el-form-item label="还款日期" label-width="80px" prop="realRepaymentDate">
                        <el-date-picker
                            v-model="dialogForm.realRepaymentDate"
                            type="date"
                            style="width:100%"
                            @change="selectValue"
                            placeholder="请选择还款日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="银行流水" label-width="80px" prop="bankFlowNo">
                        <el-input v-model="dialogForm.bankFlowNo" autocomplete="off" placeholder="请输入银行流水" ></el-input>
                    </el-form-item>
                    <el-form-item label="备注信息" label-width="80px" prop="remark" >
                        <el-input type="textarea" :rows="3" v-model="dialogForm.remark" autocomplete="off" placeholder="添加备注信息" ></el-input>
                    </el-form-item>
                </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmForm">{{isEdit?'保 存':'确 定'}}</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import '../assets/js/timeFomart'
export default {
    data(){
        return{
            option: {
                filter: '',
                pageSize: 15,
                pageIndex: 1
            },
            dialogForm: {
                id: 0,
                realRepaymentDate: '',
                bankFlowNo: '',
                remark: ''
            },
            formRules:{
                realRepaymentDate:[{
                    required: true,
                    message: "请选择还款日期",
                    trigger: "blur"
                }],
                bankFlowNo:[{
                    required: true,
                    message: "请输入银行流水号",
                    trigger: "blur"
                }],
            },
            pageTotal: 1,
            isEdit: false,
            dialogFormVisible: false,
            list: [],
            inputValue: '',
        }
    },
    methods:{
        //获取list
        getList(option){
            this.$api.LoanList(option).then(res=>{
                this.list = res.data.data.data;
                this.pageTotal = res.data.data.total;
                this.statusFormart(this.list);
            })
        },
        //获取页码
        currentPage(option){
            this.option.pageIndex = option;
            this.getList(this.option);
        },
        //选择还款日期
        selectValue(){
            this.dialogForm.realRepaymentDate = this.dialogForm.realRepaymentDate.format("yyyy-MM-dd");
        },
        //处理还款状态函数
        statusFormart(option){
            if(option.length==0) return;
            option.map((item,i)=>{
                switch (item.status) {
                    case 0:
                        item.color = '#AD454E'
                        item.status = '未还款'
                        break;
                    case 1:
                        item.color = '#AD454E'
                        item.status = '已超期'
                        break;
                    case 2:
                        item.color = '#EDB941'
                        item.status = '超期还款'
                        break;
                    case 3:
                        item.color = '#6D9E7B'
                        item.status = '已还款'
                        break;
                }
            })
        },
        //表格前编号
        indexMethod(index) {
            return index+1 ;
        },
        //表格隔行变色，样式在app.vue里
        TableRowClassName({row,rowIndex}){
            if(rowIndex%2 != 0){
                return 'backtablegray'
            }else{
                return 'backtablewhite'
            }
        },
        //获取搜索框值
        getInputValue(option){
            this.inputValue = option;
            this.option.filter = option;
        },
        //搜索按钮
        search(){
            this.getList({
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1
            });
        },
        //添加按钮
        add(){
            this.isEdit = false;
            this.dialogFormVisible = true;
        },
        //编辑按钮
        edit(row) {
            this.isEdit = true;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: row.id,
                realRepaymentDate: '',
                bankFlowNo: '',
                remark: ''
            };
        },
        //dialog提交按钮
        confirmForm(){
            this.$refs.formRules.validate(valid=>{
                if(valid){
                    //可以提交
                    this.$api.Repayment(this.dialogForm).then(res=>{
                        if(res.data.code == 200){
                            this.getList(this.option);
                            this.$notify({
                                message: res.data.msg,
                                type: 'success'
                            })
                        }else{
                            this.$notify({
                                message: res.data.msg,
                                type: 'error'
                            })
                        }
                    })
                    this.dialogFormVisible = false;
                }else{
                    return false
                }
            })
        }
    },
    mounted(){
        this.getList(this.option);
    }
}
</script>

<style lang='scss' scoped>
.container{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
main{
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 8px;
}
</style>